export default __webpack_public_path__ + "static/media/moca-hashtag.3c7a2597.png";